/* tslint:disable */
/* eslint-disable */
/* @relayHash 12e022033a9b77cff3951468123dd1f6 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_Org_QueryVariables = {};
export type App_Org_QueryResponse = {
    readonly manager: {
        readonly " $fragmentRefs": FragmentRefs<"OrgOverview_manager">;
    } | null;
    readonly purchasedCourses: {
        readonly " $fragmentRefs": FragmentRefs<"OrgOverview_purchasedCourses">;
    } | null;
};
export type App_Org_Query = {
    readonly response: App_Org_QueryResponse;
    readonly variables: App_Org_QueryVariables;
};



/*
query App_Org_Query {
  manager {
    ...OrgOverview_manager
  }
  purchasedCourses {
    ...OrgOverview_purchasedCourses
  }
}

fragment ActivityFeedCard_company on Company {
  activity(page: {limit: 80}) {
    edges {
      type
      ...UserUpdate_activity
    }
  }
}

fragment ExpiringSoonCard_company on Company {
  upcomingExpirations(page: {limit: 80}) {
    edges {
      delegateUUID
      delegateName
      itemName
      expiryDate
    }
  }
}

fragment OrgOverview_manager on Manager {
  firstName
  lastName
  email
  telephone
  lastLogin
  company {
    name
    delegates {
      pageInfo {
        total
      }
    }
    certificatesStatus {
      totals {
        available
        expired
        expiringSoon
        incomplete
      }
    }
    ...StatusCard_company
    ...ActivityFeedCard_company
    ...ExpiringSoonCard_company
  }
}

fragment OrgOverview_purchasedCourses on PurchasedCoursePage {
  edges {
    counts {
      expiringTakers
    }
  }
}

fragment StatusCard_company on Company {
  certificatesStatus {
    secondaryCategoryStatuses {
      secondaryCategory {
        name
        uuid
      }
      totals {
        available
        expired
        expiringSoon
        incomplete
      }
    }
  }
  simulatorCompliance {
    activeUsers
    compliantUsers
    uncompliantUsers
  }
  documentStatus {
    available
    expired
    expiringSoon
    incomplete
  }
  backgroundCheckStatus {
    available
    expired
    expiringSoon
    incomplete
  }
}

fragment UserUpdate_activity on Activity {
  type
  createdAt
  course {
    __typename
    name
  }
  user {
    uuid
    firstName
    lastName
    profileImageUrl
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v3 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "available",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "expired",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "expiringSoon",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "incomplete",
            "args": null,
            "storageKey": null
        } as any)
    ], v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "totals",
        "storageKey": null,
        "args": null,
        "concreteType": "ExpiryStatus",
        "plural": false,
        "selections": (v3 /*: any*/)
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "Literal",
            "name": "page",
            "value": {
                "limit": 80
            }
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_Org_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "OrgOverview_manager",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "purchasedCourses",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PurchasedCoursePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "OrgOverview_purchasedCourses",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_Org_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        (v1 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "telephone",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastLogin",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "delegates",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "DelegatePage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "total",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "certificatesStatus",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CompanyCertificateStatus",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "secondaryCategoryStatuses",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SecondaryCategoryCertificateStatus",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "secondaryCategory",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SecondaryCategory",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v5 /*: any*/)
                                                    ]
                                                },
                                                (v4 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "simulatorCompliance",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SimulatorCompliance",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "activeUsers",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "compliantUsers",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "uncompliantUsers",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "documentStatus",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ExpiryStatus",
                                    "plural": false,
                                    "selections": (v3 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "backgroundCheckStatus",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ExpiryStatus",
                                    "plural": false,
                                    "selections": (v3 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "activity",
                                    "storageKey": "activity(page:{\"limit\":80})",
                                    "args": (v6 /*: any*/),
                                    "concreteType": "ActivityPage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Activity",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "type",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "createdAt",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "course",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "__typename",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "user",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v0 /*: any*/),
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "profileImageUrl",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "upcomingExpirations",
                                    "storageKey": "upcomingExpirations(page:{\"limit\":80})",
                                    "args": (v6 /*: any*/),
                                    "concreteType": "UpcomingExpirationPage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UpcomingExpiration",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "delegateUUID",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "delegateName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "itemName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "expiryDate",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "purchasedCourses",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PurchasedCoursePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PurchasedCourse",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "counts",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PurchasedCourseCount",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expiringTakers",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_Org_Query",
            "id": null,
            "text": "query App_Org_Query {\n  manager {\n    ...OrgOverview_manager\n  }\n  purchasedCourses {\n    ...OrgOverview_purchasedCourses\n  }\n}\n\nfragment ActivityFeedCard_company on Company {\n  activity(page: {limit: 80}) {\n    edges {\n      type\n      ...UserUpdate_activity\n    }\n  }\n}\n\nfragment ExpiringSoonCard_company on Company {\n  upcomingExpirations(page: {limit: 80}) {\n    edges {\n      delegateUUID\n      delegateName\n      itemName\n      expiryDate\n    }\n  }\n}\n\nfragment OrgOverview_manager on Manager {\n  firstName\n  lastName\n  email\n  telephone\n  lastLogin\n  company {\n    name\n    delegates {\n      pageInfo {\n        total\n      }\n    }\n    certificatesStatus {\n      totals {\n        available\n        expired\n        expiringSoon\n        incomplete\n      }\n    }\n    ...StatusCard_company\n    ...ActivityFeedCard_company\n    ...ExpiringSoonCard_company\n  }\n}\n\nfragment OrgOverview_purchasedCourses on PurchasedCoursePage {\n  edges {\n    counts {\n      expiringTakers\n    }\n  }\n}\n\nfragment StatusCard_company on Company {\n  certificatesStatus {\n    secondaryCategoryStatuses {\n      secondaryCategory {\n        name\n        uuid\n      }\n      totals {\n        available\n        expired\n        expiringSoon\n        incomplete\n      }\n    }\n  }\n  simulatorCompliance {\n    activeUsers\n    compliantUsers\n    uncompliantUsers\n  }\n  documentStatus {\n    available\n    expired\n    expiringSoon\n    incomplete\n  }\n  backgroundCheckStatus {\n    available\n    expired\n    expiringSoon\n    incomplete\n  }\n}\n\nfragment UserUpdate_activity on Activity {\n  type\n  createdAt\n  course {\n    __typename\n    name\n  }\n  user {\n    uuid\n    firstName\n    lastName\n    profileImageUrl\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '03cecf1c86c1493235fdce7b84acadcb';
export default node;
